/* eslint-disable no-return-assign */
/* eslint-disable react/prop-types */
import { GLOBAL_DATE_FORMAT } from 'constant';
import moment from 'moment';

export function SignView({ data, parent }) {
    const isSigned = data?.is_signed_by_therapist || data?.is_full_signed;
    const signedDate = data?.therapist_sign_date || data?.signed_on || data?.signed_date;
    const parsedSignedDate = signedDate ? moment.utc(signedDate).local() : null;
    const formattedSignedDate = parsedSignedDate?.isValid() ? parsedSignedDate.format(`${GLOBAL_DATE_FORMAT} hh:mm A`) : '-';
    const signedByName = data?.signed_therapist_emp?.name || data?.therapist?.name || '';
    const signedByCredentials = data?.signed_therapist_emp?.credentials || data?.therapist?.credentials || '';
    const signedBy = [signedByName, signedByCredentials].filter(Boolean).join(', ');

    return (
        <div className="e-sign">
            {isSigned && (
                <div
                    className="sign-info"
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: parent === 'view' ? 'flex-start' : 'center' // adjust as needed
                    }}
                >
                    <p>Signed by</p>
                    <p>
                        <b>{signedBy || '-'}</b> on <b>{formattedSignedDate}</b>
                    </p>
                </div>
            )}
            {/* {data?.is_signed_by_supervisor && (
                <div className="sign-info">
                    <p>Signed by</p>
                    <p>
                        <b>
                            {data?.signed_supervisor_emp?.name || ''}, {data?.signed_supervisor_emp?.credentials || ''}
                        </b>{' '}
                        on <b>{moment.utc(data?.supervisor_sign_date).local().format(`${GLOBAL_DATE_FORMAT} hh:mm A`)}</b>
                    </p>
                </div>
            )} */}
        </div>
    );
}
